var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCommentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90345 31.3959C5.01236 30.9961 4.77165 30.4402 4.54193 30.0395C4.4704 29.92 4.39281 29.8043 4.30946 29.6927C2.33918 26.7127 1.28903 23.2216 1.28915 19.6521C1.25712 9.40626 9.7762 1.0918 20.3107 1.0918C29.4979 1.0918 37.1667 7.43923 38.9587 15.865C39.2272 17.1143 39.3628 18.3882 39.3633 19.6658C39.3633 29.9263 31.1728 38.3713 20.6383 38.3713C18.9634 38.3713 16.7028 37.9514 15.4699 37.6073C14.2371 37.2632 13.0061 36.8068 12.6885 36.6845C12.3637 36.56 12.0187 36.496 11.6708 36.4956C11.2907 36.4941 10.9142 36.5696 10.5642 36.7174L4.35613 38.9518C4.22013 39.0103 4.07601 39.0479 3.92871 39.0632C3.81248 39.0629 3.69746 39.0395 3.59034 38.9945C3.48321 38.9495 3.3861 38.8838 3.30463 38.8011C3.22317 38.7184 3.15896 38.6204 3.11574 38.5128C3.07251 38.4052 3.05113 38.2901 3.05283 38.1742C3.06046 38.0724 3.07887 37.9718 3.10774 37.8739L4.90345 31.3959Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommentWhite);
export default __webpack_public_path__ + "static/media/IconCommentWhite.198048542504c6f77cf6fb895dbdb5f5.svg";
export { ForwardRef as ReactComponent };